/**
 * Membership role reference data (T12, frontend-only). Single source for the
 * Settings Team/Security/Invite role labels, chip palette, invite copy, and
 * downgrade detection — pages import these instead of inlining role arrays.
 * Mirrors the backend RBAC roles until a server-driven source replaces it.
 *
 * `owner` is set by ownership transfer, never by invite, so `INVITE_ROLES` and
 * `ASSIGNABLE_ROLES` intentionally exclude it.
 */

/** Role key → display label. */
const ROLE_LABEL = {
  owner: 'Owner',
  manager: 'Manager',
  lister: 'Lister',
  viewer: 'Viewer',
};

/** Role chip palette per the .pen Team frame: Owner=indigo, Manager=emerald,
 * Lister=amber, Viewer=neutral. */
const ROLE_CHIP = {
  owner: 'bg-primary/15 text-primary',
  manager: 'bg-success/15 text-success',
  lister: 'bg-warning/15 text-warning',
  viewer: 'bg-surface-2 text-ink-muted',
};

/** Role rank for downgrade detection (owner highest). */
const ROLE_RANK = { owner: 3, manager: 2, lister: 1, viewer: 0 };

/** Invitable roles with copy from the .pen Invite Modal (CjDPp). `[key, label,
 * description]`. Owner is set by transfer, not invite, so it is excluded. */
const INVITE_ROLES = [
  ['manager', 'Manager', 'Runs operations — everything except billing & danger zone.'],
  ['lister', 'Lister', 'Adds & lists parts. Cannot see financials (ROI, revenue).'],
  ['viewer', 'Viewer', 'Read-only access across the app.'],
];

/** Roles assignable from the member-row role select (no Owner). */
const ASSIGNABLE_ROLES = ['manager', 'lister', 'viewer'];

export {
  ASSIGNABLE_ROLES,
  INVITE_ROLES,
  ROLE_CHIP,
  ROLE_LABEL,
  ROLE_RANK,
};
